export default __webpack_public_path__ + "static/media/iva_xl.11ca8f67.jpg";